import { ActivityHeader } from "components/Header/ActivityHeader";
import Header from "components/Header/Header";
import Sidebar from "components/Sidebar/Siderbar";
import { CatalogSettingProvider } from "context/CatalogSettingContext";
import { FilterProvider } from "context/FilterContext";
import { GlobalProvider } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, forwordRouteAccordingToNewRights, forwordRouteAccordingToRights, hasAccessPage, isAllowed } from "utils/checkUserRigths";
import SortContextProvider from "context/sortContextProvider";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { clearCart } from "store/cartSlice";
import "./main-layout-style.css";
import { usePermissionFlags } from "utils/visionRights";

const MainLayout = () => {
  const permissions = usePermissions();
  const [hasAccess, setHasAccess] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;
  const innerChnages = state && state.innerChnages ? state.innerChnages : false;
  const edit = state && state.edit ? state.edit : false;
  const isActivity = state && state.isActivity ? state.isActivity : false;
  const dispatch = useDispatch();
  const noRights = ["Clients", "CartOrder", "aiStock", "Client-Details","reorder-stock-view"];
  const { showClients, stockLocations } = usePermissionFlags();

  useEffect(() => {
    if (permissions) {
      let nextRoute = forwordRouteAccordingToNewRights(permissions);
      if (location.pathname === "/") {
        navigate(nextRoute);
        return;
      }

      let path = location.pathname.split("/")[1];
      let accessGranted = false;

      if (path === "Cart") {
        setHasAccess(true);
      } else {
        const secondSegment = location.pathname.split("/")[2] || "";
        path = path === "Stock" || /^[0-9a-f]{24}$/i.test(secondSegment) ? "Stocks" : path
        if (path === "Stocks") {
          accessGranted = stockLocations?.length > 0 && (noRights?.includes(path) ? true : isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), `${path} Access`), "view"));
        }
        else {
          accessGranted = noRights?.includes(path) ? true : isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), `${path} Access`), "view");
        }

        if (!accessGranted) {
          if (nextRoute === "/Clients" && !showClients) {
            console.warn("No accessible routes found");
            setHasAccess(false);
            return;
          }

          if (nextRoute && nextRoute !== location.pathname) {
            navigate(nextRoute);
          } else {
            console.warn("No accessible routes found");
            setHasAccess(false);
          }

          return;
        }
        // const accessGranted = true;
        setHasAccess(accessGranted);
      }

      if (state?.newName !== "Create Order" && state?.newName !== "Cart" && !innerChnages) {
        dispatch(clearCart());
      }
    }
  }, [location.pathname, permissions, navigate]);


  const AccessContent = () => {
    return hasAccess ? <Outlet /> : <p style={{ color: "black" }}>Not Access</p>;
  };

  return (
    <>
      <GlobalProvider>
        <FilterProvider>
          <SortContextProvider>
            <CatalogSettingProvider>
              <div className={`${!innerChnages && !edit ? "main-layout" : "main-layout-left"}`}>
                {!isActivity ? <Header /> : <ActivityHeader />}
                <div className="main-body">
                  {!innerChnages && !edit ? <Sidebar /> : ""}
                  <div className="content">
                    <AccessContent />
                  </div>
                </div>
              </div>
            </CatalogSettingProvider>
          </SortContextProvider>
        </FilterProvider>
      </GlobalProvider>
    </>
  );
};

export default MainLayout;
